import { render, staticRenderFns } from "./EmployeePositionItemEditor.vue?vue&type=template&id=b7b038d4&"
import script from "./EmployeePositionItemEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeePositionItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports